import RightPane from "./RightPane";

export default RightPane;